module.exports = __webpack_public_path__ + "img/merchant.37eb2bbb.png";